import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="min-h-screen bg-surface-0 flex flex-col items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_top,rgba(59,130,246,0.2),transparent_45%)]" />
      {/* Brand header */}
      <div className="flex items-center gap-3 mb-8 relative z-10">
        <img src="/logo.png" alt="Navyrx Sports" className="w-10 h-10 object-contain flex-shrink-0" />
        <span className="font-bold text-2xl text-gray-100 tracking-tight">
          Navyrx<span className="text-brand"> Sports</span>
        </span>
      </div>

      {/* Auth card */}
      <div className="w-full max-w-md bg-surface-1/95 border border-surface-4 rounded-xl p-8 shadow-2xl backdrop-blur relative z-10">
        <Outlet />
      </div>

      <p className="mt-6 text-xs text-gray-600 relative z-10">© {new Date().getFullYear()} Navyrx Sports</p>
    </div>
  );
}
